// extracted by mini-css-extract-plugin
export default {"buyOpensea":"SimulatorBuyAvatarOpenseaButton_buyOpensea__Bi7Hw","loading":"SimulatorBuyAvatarOpenseaButton_loading__zdBb6"};